import React from "react";
import MyLinkPage from "../../components/Pages/Affiliates/MyLink/MyLink";

const MyLink = () => {
  return (
    <div>
      <MyLinkPage />
    </div>
  );
};

export default MyLink;
